import React from "react";
import { FaEnvelope, FaArrowUp, FaWhatsapp } from "react-icons/fa";
import "../styles/Footer.css";

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Brand Section */}
        <div className="footer-section footer-brand">
          <h3>Engineer K</h3>
          <p>Providing expert technology solutions for businesses worldwide.</p>
          <div className="social-links">
            <a
              href="https://wa.me/254743678908"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon whatsapp-icon"
              aria-label="WhatsApp"
              title="Message us on WhatsApp"
            >
              <FaWhatsapp />
            </a>
            <a
              href="mailto:securedev001@gmail.com"
              className="social-icon email-icon"
              aria-label="Email us"
              title="Email us"
            >
              <FaEnvelope />
            </a>
          </div>
        </div>
        {/* Services Section */}
        <div className="footer-section">
          <h4>Services</h4>
          <ul>
            <li>
              <a href="/software-web-development">Software & Web Development</a>
            </li>
            <li>
              <a href="/cybersecurity">Cybersecurity</a>
            </li>
            <li>
              <a href="/tech-repair">Tech Repair & Support</a>
            </li>
            <li>
              <a href="/#portfolio">Portfolio</a>
            </li>
          </ul>
        </div>
        {/* Quick Links Section */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <a href="/#hero">Home</a>
            </li>
            <li>
              <a href="/#portfolio">Portfolio</a>
            </li>
            <li>
              <a href="/#contact">Contact</a>
            </li>
            <li>
              <a href="/#services">Services</a>
            </li>
          </ul>
        </div>
        {/* Contact Section */}
        <div className="footer-section footer-contact">
          <h4>Get In Touch</h4>

          <div className="contact-item">
            <FaWhatsapp className="contact-icon" />
            <div>
              <p>WhatsApp</p>
              <a
                href="https://wa.me/254743678908"
                target="_blank"
                rel="noopener noreferrer"
              >
                Message Us
              </a>
            </div>
          </div>

          <div className="contact-item">
            <FaEnvelope className="contact-icon" />
            <div>
              <p>Email</p>
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=securedev001@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Open in Gmail
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>&copy; 2026 Engineer K. All rights reserved.</p>
        <button
          className="scroll-to-top"
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <FaArrowUp />
        </button>
      </div>
    </footer>
  );
}

export default Footer;
